/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { DatasetBriefDto } from './DatasetBriefDto';
import type { RecommendationMonitorDto } from './RecommendationMonitorDto';

export type GetRecommendationSessionResponseDto = {
    createdBy: string;
    createdDate: number;
    datasets?: Array<DatasetBriefDto>;
    domainId: string;
    id: string;
    lastModifiedDate: number;
    metadataJobIds?: Array<string>;
    modifiedBy: string;
    name: string;
    recommendationMonitors?: Array<RecommendationMonitorDto>;
    status?: GetRecommendationSessionResponseDto.status;
    step: GetRecommendationSessionResponseDto.step;
};

export namespace GetRecommendationSessionResponseDto {

    export enum status {
        NOT_STARTED = 'NOT_STARTED',
        RUNNING = 'RUNNING',
        SUCCESS = 'SUCCESS',
        ERROR = 'ERROR',
    }

    export enum step {
        ASSET_SELECTION = 'ASSET_SELECTION',
        MANUAL_ASSET_SELECTION = 'MANUAL_ASSET_SELECTION',
        MONITOR_RECOMMENDATION = 'MONITOR_RECOMMENDATION',
    }


}
